import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';
import { PRICING_ACTION_ENABLE } from './pricing-action-permissions';

/**
 * Route guard for the per-tenant Pricing Action Loop enablement admin surface.
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `pricing_action.enable` is present. Tenant users
 * and super_users without the grant are bounced to `/home`.
 *
 * Mirrors `dataScopeAdminGuard` — same surface, different permission key.
 */
export const pricingActionAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes(PRICING_ACTION_ENABLE)) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
